import usePaging from 'new/state/paging/repository/usePaging';
import useProbe from 'new/state/probe/repository/useProbe';
import createFileSystemService from 'new/components/flows/configure/FileSystem/service/createFileSystemService';
import useProbeAdapter from 'new/state/probe/adapter/useProbeAdapter';
import { useCallback } from 'react';
import useApp from 'new/state/app/repository/useApp';

export default function useFileSystem({ selectedConnection, credentialId, flowType }) {
  const { paging, getSinkConfigFields, getSourceConfigFields, getMetaInfoById } = usePaging();
  const { getProbeData, toggleTreeNode } = useProbe();
  const { setContextualSupport, unsetContextualSupport } = useApp();
  const service = createFileSystemService();
  const { requestConnectionTree } = useProbeAdapter();

  const sinkConfigFields = getSinkConfigFields(selectedConnection, flowType);
  const sourceConfigFields = getSourceConfigFields(selectedConnection, flowType);

  const onToggleNodeProbeTree = useCallback((node) => {
    toggleTreeNode(credentialId, node);
  }, []);

  const onRequestProbeTree = useCallback(
    (root, folder) => {
      requestConnectionTree(credentialId, root, folder);
    },
    [requestConnectionTree, credentialId],
  );

  const getBucketConfig = useCallback((bucket) => {
    return service.getBucketConfig(bucket);
  }, []);

  return {
    paging,
    sinkConfigFields,
    sourceConfigFields,
    getBucketConfig,
    onRequestProbeTree,
    onToggleNodeProbeTree,
    setContextualSupport,
    unsetContextualSupport,
    selectedConnectionDetails: getMetaInfoById(selectedConnection),
    sinkConfigFieldsForFile: service.getSinkFieldsForFile(sinkConfigFields),
    getProbeData,
  };
}
